import React, { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import 'moment/locale/ko';
import moment from 'moment';
import styled from 'styled-components';
import CustomTable from '../../components/CustomTable';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { addMonths } from 'date-fns';
import SettlementController, { SettlementListType } from '../../controller/SettlementController';
import StoreController, { CurrentStoreContext } from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import ExcelJS from 'exceljs';

const SalesSettle = () => {
  const nowDate = new Date();
  const currentDayOfWeek = nowDate.getDay();
  // 이번주
  const weekStartDate = new Date(nowDate);
  weekStartDate.setDate(nowDate.getDate() - currentDayOfWeek + (currentDayOfWeek === 0 ? -6 : 1));
  const weekEndDate = new Date(weekStartDate);
  weekEndDate.setDate(weekStartDate.getDate() + 6);
  // 이번달
  const monthStartDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
  const monthEndDate = new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
  const [selectType, setSelectType] = useState<number>(0);
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [startDate, setStartDate] = useState<Date>(weekStartDate);
  const [endDate, setEndDate] = useState<Date>(weekEndDate);
  const [selectedDateRange, setSelectedDateRange] = useState<[Date, Date]>([nowDate, nowDate]);
  const [settlementList, setSettlementList] = useState<SettlementListType[]>([]);
  const [hotelSettlementList, setHotelSettlementList] = useState<
    {
      store_id: number;
      hotel_name: string;
      settlement_start_date: string;
      settlement_end_date: string;
      transfer_status: number;
      order_amount: number;
      store_discount_amt: number;
      com_discount_amt: number;
      delivery_price: number;
      final_payment_amt: number;
      payment_fee: number;
      relay_fee: number;
      vat: number;
      total_deductions: number;
      scheduled_settlement_amt: number;
      deposit_status: string;
      room_tip: number;
    }[]
  >([]);
  const [totalScheduledSettlement, setTotalScheduledSettlement] = useState<number>();
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean[]>(new Array(settlementList?.length).fill(false));
  const storeId = currentStore.value;

  const excelHeader = [
    '주문번호',
    '주문일자',
    '호텔명',
    '(A)주문금액',
    '(B1)매장부담 할인금액',
    '(B2)노크노크부담 할인금액',
    '(C)배달팁',
    '(D)매출총액',
    '(E)결제수수료',
    '(F)중계수수료',
    '(G)부가세',
    '(H)공제총액',
    '(I)정산예정금액',
    '카드사',
  ];

  const tableHeader = ['입금일', '영업기간', '입금금액 (예정 포함)'];
  const renderTableItem = () => {
    return (
      <>
        {settlementList?.length > 0 ? (
          settlementList.map((item, index: number) => (
            <div>
              <div key={index} className="listContent web">
                <p>{moment(item.scheduled_date).format('MM/DD')}</p>
          
                <p>
                  {moment(item.settlement_start_date).format('MM/DD')} -
                  {moment(item.settlement_end_date).format('MM/DD')}
                </p>
                <p>{item.scheduled_settlement_amt.toLocaleString()}원</p>
                <div className="buttons">
                  <div
                    onClick={() => excelDownloadClick(item.scheduled_date, item.scheduled_date)}
                    className="webView">
                    <button>건별 정산명세서 받기</button>
                  </div>

                  <div className="mobileView">
                    <button className="downloadBtn">
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_download.svg`}
                        alt="다운로드아이콘"
                      />
                    </button>
                  </div>
                  <img
                    src={`${process.env.PUBLIC_URL}/svg/ic_arrow_${
                      isOpen[index] ? 'up' : 'down'
                    }_grey.svg`}
                    alt="여닫기 아이콘"
                    onClick={() => changeIsOpen(index)}
                  />
                </div>
              </div>
              {isOpen[index] && (
                <div className="detailListWrap">
                  <div className="detailList">
                    <p>(A) 주문 금액</p>
                    <p>(B1) 할인- 사장님 부담</p>
                    <p>(B2) 할인- 노크노크 부담</p>
                    <p>(C) 배달팁</p>
                    <p>(D) 매출 총액 ( A - B + C )</p>
                    <div className="guide">
                      <p>(E) 결제 수수료</p>
                      <div className="guideBoxWrap">
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                          alt="물음표아이콘"
                        />
                        <p className="guideBox">
                          <span>결제 수수료 3% (부가세 별도)</span>가 차감되어 정산됩니다 <br />
                          <span>해외카드 수수료는 4% (부가세 별도)</span>가 차감되어 정산됩니다
                        </p>
                      </div>
                    </div>
                    <div className="guide">
                      <p>(F) 중개 수수료</p>
                      <div className="guideBoxWrap">
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                          alt="물음표아이콘"
                        />
                        <p className="guideBox">
                          <span>중개 수수료 6.8% (부가세 별도)</span>가 차감되어 정산됩니다
                        </p>
                      </div>
                    </div>
                    <div className="guide">
                      <p>(G) 부가세</p>
                      <div className="guideBoxWrap">
                        <img
                          src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                          alt="물음표아이콘"
                        />
                        <p className="guideBox">
                          <span>부가세 10%</span>가 차감되어 정산됩니다
                        </p>
                      </div>
                    </div>
                    <p>(H) 공제 총액 ( E + F + G )</p>
                    <p>(I) 정산 예정 금액 ( D + B2 - H )</p>
                  </div>
                  <div className="detailList">
                    <p>{item.order_amount.toLocaleString()}원</p>
                    <p>{item.store_discount_amt.toLocaleString()}원</p>
                    <p>{item.com_discount_amt.toLocaleString()}원</p>
                    <p>{item.delivery_price.toLocaleString()}원</p>
                    <p>{(item.final_payment_amt - item.room_tip).toLocaleString()}원</p>
                    <p>{item.payment_fee.toLocaleString()}원</p>
                    <p>{item.relay_fee.toLocaleString()}원</p>
                    <p>{item.vat.toLocaleString()}원</p>
                    <p>{item.total_deductions.toLocaleString()}원</p>
                    <p>{item.scheduled_settlement_amt.toLocaleString()}원</p>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <p className="nullList">조회된 날짜에 정산 내역이 없습니다.</p>
        )}
      </>
    );
  };
  // 상세보기
  const changeIsOpen = (index: number) => {
    const dataTemp = isOpen;
    dataTemp[index] = !dataTemp[index];
    setIsOpen([...dataTemp]);
    console.log('isOpen', isOpen);
  };

  // tab
  const handleSelectBoxClick = (type: number, start: Date, end: Date) => {
    setSelectType(type);
    setStartDate(start);
    setEndDate(end);
  };
  const titleText = () => {
    let title, date;

    switch (selectType) {
      case 1:
        title = '이번달';
        date = moment(startDate).format('YYYY년 M월');
        break;
      case 2:
        title = '조회기간';
        date = '';
        break;
      default:
        title = '이번주';
        date =
          moment(startDate).format('YYYY/MM/DD') + ' - ' + moment(endDate).format('YYYY/MM/DD');
    }

    return { title, date };
  };

  // 기간조회
  const handleDateChange = (dates: [Date, Date]) => {
    setSelectedDateRange(dates);
    setStartDate(dates[0]);
    setEndDate(dates[1]);
  };

  // 정산내역 api
  const getSettlement = async () => {
    try {
      const oData = {
        store_id: storeId,
        start_date: moment(startDate).format('YYYY-MM-DD'),
        end_date: moment(endDate).format('YYYY-MM-DD'),
      };

      const response = await SettlementController.getSettlement(oData);

      if (response.data.ok) {
        setSettlementList(response.data.data.settlement_list);
        setHotelSettlementList(response.data.data.hotel_settlement_list);
        setTotalScheduledSettlement(response.data.data.total_scheduled_settlement_amt);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  // 엑셀다운로드
  const excelDownloadClick = async (startDay: any, endDay: any) => {
    try {
      const oData = {
        store_id: storeId,
        start_date: moment(startDay).format('YYYY-MM-DD'),
        end_date: moment(endDay).format('YYYY-MM-DD'),
      };

      const response = await SettlementController.getSettlementDetail(oData);

      if (response.data.ok) {
        const periodSettleExcelData = response.data.data;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet 1');
        const totalScheduledSettlementAmt = periodSettleExcelData.reduce(
          (total: any, data: any) => {
            return total + data.scheduled_settlement_amt;
          },
          0,
        );
        worksheet.mergeCells('A1:K1');
        worksheet.getCell('A1').value = '노크노크 정산 상세내역 (' + currentStore.name + ')';
        worksheet.mergeCells('A2:K2');
        worksheet.getCell('A2').value =
          '거래기간 : ' +
          moment(startDay).format('YYYY-MM-DD') +
          ' ~ ' +
          moment(endDay).format('YYYY-MM-DD');

        worksheet.addRow(excelHeader.slice(0, excelHeader.length));
        for (let i = 4; i <= 13; i++) {
          worksheet.getColumn(i).numFmt = '#,##0';
        }
        for (let i = 0; i < periodSettleExcelData.length; i++) {
          worksheet.addRow([
            periodSettleExcelData[i].bill_number,
            moment(periodSettleExcelData[i].ordered_at).format('YYYY-MM-DD HH:mm:ss'),
            periodSettleExcelData[i].hotel_name,

            periodSettleExcelData[i].order_amount,
            periodSettleExcelData[i].store_discount_amt,
            periodSettleExcelData[i].com_discount_amt,
            periodSettleExcelData[i].delivery_price,
            periodSettleExcelData[i].final_payment_amt - periodSettleExcelData[i].room_tip,
            periodSettleExcelData[i].payment_fee,
            periodSettleExcelData[i].relay_fee,
            periodSettleExcelData[i].vat,
            periodSettleExcelData[i].total_deductions,
            periodSettleExcelData[i].scheduled_settlement_amt,
            periodSettleExcelData[i].issuer_name,
          ]);
        }

        // 아래 총합계
        const lastRowIndex = periodSettleExcelData.length + 4;
        worksheet.mergeCells('A' + lastRowIndex + ':K' + lastRowIndex);
        worksheet.getCell('A' + lastRowIndex).value =
          '총 정산 예정 금액' + totalScheduledSettlementAmt.toLocaleString() + '원';

        // 엑셀 파일로 저장
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `노크노크 정산 상세내역_${moment(startDate).format('YYYY-MM-DD')}_${moment(
              endDate,
            ).format('YYYY-MM-DD')}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
        });
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  useEffect(() => {
    getSettlement();
  }, [startDate, endDate]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Style>
      <div className="contentContainer">
        <div className="header">
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${selectType === 0 && 'active'}`}
              onClick={() => handleSelectBoxClick(0, weekStartDate, weekEndDate)}>
              이번주
            </div>
            <div
              className={`selectBox center ${selectType === 1 && 'active'}`}
              onClick={() => handleSelectBoxClick(1, monthStartDate, monthEndDate)}>
              이번달
            </div>
            <div
              className={`selectBox right ${selectType === 2 && 'active'}`}
              onClick={() => {
                handleSelectBoxClick(2, nowDate, nowDate);
                setSelectedDateRange([nowDate, nowDate]);
              }}>
              조회기간
            </div>
          </div>
          <div className="subHeader">
            {selectType === 2 && (
              <div className="selectDateWrap">
                <div className="calendarWrap">
                  <DatePicker
                    id={'dateRangePicker'}
                    className="datePicker"
                    onChange={(update: any) => handleDateChange(update)}
                    startDate={selectedDateRange[0]}
                    endDate={selectedDateRange[1]}
                    maxDate={addMonths(startDate, 6)}
                    selectsRange={true}
                    dateFormat="yyyy-MM-dd"
                    locale="ko"
                    monthsShown={isMobile ? 1 : 2}
                    isClearable={false}
                    disabledKeyboardNavigation={true}
                    onFocus={(e) => {
                      e.preventDefault();
                      e.target.blur();
                    }}
                  />

                  <label className="calendar" htmlFor={`dateRangePicker`}>
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_calendar.svg`} alt="달력아이콘" />
                  </label>
                </div>
                <button onClick={getSettlement} className="searchButton">
                  조회
                </button>
              </div>
            )}
            <div className="nowDateWrap">
              <h2>
                {titleText().title} 정산 금액은
                <strong> {totalScheduledSettlement?.toLocaleString()}원</strong> 입니다
                <span>(예정 포함)</span>
              </h2>
              <h3>
                {/* {titleText().date} */}
                {selectType === 0 && <span>* 매주 수요일에 정산됩니다</span>}
              </h3>
              <h3>
                {selectType === 0 && (
                  <span>
                    * 호텔에 따라 입금자명이 상이할 수 있습니다 (인비저블아이디어, 페이시스,
                    나이스페이먼츠)
                  </span>
                )}
              </h3>
            </div>
            {hotelSettlementList.length > 0 && (
              <div className="hotelList">
                <h3>호텔별</h3>
                <div className="flex">
                  {hotelSettlementList.map((data) => (
                    <div className={`hList ${hotelSettlementList.length > 5 && 'wrap'}`}>
                      <h4>{data.hotel_name}</h4>
                      <h4 className="price">{data.scheduled_settlement_amt?.toLocaleString()}원</h4>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="contentContainer">
        <button onClick={() => excelDownloadClick(startDate, endDate)} className="excelDownload">
          <p>기간 전체 정산 명세서 받기</p>
        </button>
        <div className="periodListTable">
          <CustomTable tableHeader={tableHeader} renderTableItem={renderTableItem} />
        </div>
      </div>
    </Style>
  );
};

export default SalesSettle;

const Style = styled.div`
  .mobileView {
    display: none;
  }

  /* contentContainer */
  .contentContainer:nth-child(1) {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0;
  }
  .contentContainer:nth-child(3) {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
  }

  /* header */
  .header {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  /* selectBoxWrap */
  .selectBoxWrap {
    display: flex;
    align-items: center;
    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #fff;
      font-size: 16px;
      color: #979797;
      padding: 12px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
    }
    .selectBox.center {
      margin: 0 -1px;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
      z-index: 2;
    }
  }

  /* subHeader */
  .subHeader {
    margin-top: 23px;
    .selectDateWrap {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 31px;
      .dateSelect {
        flex: 1;
      }
      img {
        position: absolute;
        top: 20%;
        right: 5%;
      }
      .searchButton {
        white-space: nowrap;
        margin-left: 10px;
        padding: 10px 32px;
        border: 1px solid #4dd2ae;
        font-size: 14px;
        font-weight: 500;
        color: #4dd2ae;
        border-radius: 5px;
      }
    }
    .nowDateWrap {
      h3 {
        font-size: 16px;
        font-weight: 400;
        color: #a7a7a7;
      }
      h2 {
        margin-top: 6px;
        margin-bottom: 10px;
        font-size: 24px;
        font-weight: 700;
        color: #555;
      }
      span {
        margin-left: 7px;
        color: #a7a7a7;
        font-size: 17px;
        font-weight: 500;
      }
      span:nth-child(1) {
        margin-left: 0;
        font-size: 14px;
        font-weight: 400;
      }
      strong {
        color: #4dd2ae;
        font-weight: 700;
      }
    }
  }
  .calendarWrap {
    position: relative;
    width: 100%;
    .calendar {
      position: absolute;
      right: 20px;
      top: 9px;
    }
  }

  /* content */
  .content {
    margin-bottom: 33px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
    .item {
      flex: 1;
      max-width: 30%;
      text-align: center;
      h2 {
        font-size: 20px;
        font-weight: 600;
        color: #555;
      }
      h3 {
        margin-bottom: 10px;
        word-break: keep-all;
        font-size: 16px;
        font-weight: 600;
        color: #979797;
      }
    }
    .pointBox {
      display: inline-block;
      margin-top: 5px;
      padding: 6px 8px;
      border: 1px solid #ff7e7e;
      border-radius: 50px;
      font-size: 10px;
      font-weight: 500;
      color: #ff7e7e;
    }
  }
  /* hotelList */
  .hotelList {
    margin-top: 22px;

    h3 {
      font-size: 14px;
      color: #979797;
    }
    h4 {
      font-size: 16px;
      font-weight: 500;
      color: #555;
    }
    span {
      font-size: 14px;
      font-weight: 400;
      color: #a7a7a7;
    }
  }
  .flex {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 5%;
  }
  .hList {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .price {
      color: #4dd2ae;
    }
  }
  .hList.wrap {
    width: 45%;
  }

  /* excelDownload */
  .excelDownload {
    display: flex;
    margin-left: auto;
    padding: 6px 10px;
    background: #f7f7f7;
    border: 1px solid #cecece;
    border-radius: 5px;
    p {
      font-size: 14px;
      font-weight: 600;
      color: #555;
    }
  }

  /* periodListTable */
  .periodListTable {
    margin: 23px 0;
    button {
      padding: 5px 10px 2px 10px;
      line-height: auto;
      border: 1px solid #cecece;
      white-space: nowrap;
      font-size: 12px;
      font-weight: 500;
      color: #979797;
      border-radius: 5px;
    }
  }
  .listTitle,
  .listContent {
    justify-content: flex-start !important;
    gap: 7px !important;
  }

  .listTitle h2,
  .listContent p {
    text-align: center;
  }
  .listTitle h2 {
    white-space: nowrap;
  }
  .listContent p {
    font-size: 13px !important;
  }
  .listTitle h2:nth-child(1),
  .listContent p:nth-child(1) {
    flex: 0 0 15%;
    width: 15%;
  }
  .listContent p:nth-child(1) {
    text-align: center;
  }
  .listTitle h2:nth-child(2),
  .listContent p:nth-child(2) {
    flex: 0 0 15%;
    width: 15%;
  }
  .listTitle h2:nth-child(3),
  .listContent p:nth-child(3) {
    flex: 0 0 15%;
    width: 15%;
  }
  .listTitle h2:nth-child(4),
  .listContent p:nth-child(4) {
    flex: 0 0 20%;
    width: 20%;
  }
  .listContent button {
    margin-left: auto;
    padding: 6px 5px 4px 5px;
    color: #555555;
    font-size: 12px;
    font-weight: 500;
    background: #f7f7f7;
    border: 1px solid #cecece;
  }
  .listContent img {
    margin-left: auto;
    margin: 0;
  }
  .refund {
    color: #ff6060 !important;
  }
  .nullList {
    padding: 24px 0;
    font-size: 16px;
    text-align: center;
  }
  .buttons {
    display: flex;
    align-items: center;
    margin-left: auto;

    .downloadBtn {
      background: none;
      border: none;
    }
    img {
      margin-left: 4px;
    }
  }
  /* detailListWrap */
  .detailListWrap {
    display: flex;
    padding-top: 12px;
    background: #f7f7f7;

    p {
      margin-bottom: 10px;
      font-size: 11px;
    }
  }
  .detailList:nth-child(1) {
    flex: 0 0 70%;

    p {
      width: auto;
      margin-left: 50%;
    }
  }
  .detailList:nth-child(2) {
    flex: 1;

    p {
      text-align: right;
      margin-right: 30%;
    }
  }

  /* react-datepicker */
  .react-datepicker {
    display: flex;
  }
  .react-datepicker-wrapper {
    width: 100%;
  }
  .react-datepicker__input-container {
    /* z-index:1; */
    input {
      background: none;
    }
  }

  /* 말풍선 */
  .guide {
    display: flex;
    align-items: center;

    img {
      margin-bottom: 8px;
      margin-left: 4px;
    }
  }
  .guideBoxWrap {
    position: relative;
    display: inline-block;
  }
  .guideBox {
    display: none;
    position: absolute;
    width: auto;
    white-space: nowrap;
    padding: 8px 12px;
    left: -72px;
    border-radius: 5px;
    border: 1px solid #e5e5e5;
    background: #edeeee;
    color: #555;
    font-size: 12px;
    font-weight: 500;
    box-shadow: 3px 3px 7.5px 0px rgba(0, 0, 0, 0.1);
    top: 18px;
    z-index: 99;

    span {
      color: #4dd2ae;
      font-weight: 700;
    }
  }
  img:hover + p.guideBox {
    display: block;
  }
  @media (max-width: 700px) {
    .mobileView {
      display: block;
    }
    .webView {
      display: none;
    }
    .subHeader {
      .nowDateWrap {
        h2 {
          font-size: 20px;
        }
        span {
          font-size: 14px;
          width: 100%;
        }
        h3 {
          width: 100%;
          display: flex;
          flex-direction: column;
        }
        span:nth-child(1) {
          margin-left: 0px;
        }
      }
    }
    .listTitle,
    .listContent {
      padding: 8px 16px !important;
    }
    .listContent p {
      font-size: 11px !important;
    }
    .listTitle h2:nth-child(1),
    .listContent p:nth-child(1) {
      flex: 0 0 10%;
      width: 10%;
      text-align: center;
    }
    .listTitle h2:nth-child(2),
    .listContent p:nth-child(2) {
      flex: 0 0 14%;
      width: 14%;
    }
    .listTitle h2:nth-child(3),
    .listContent p:nth-child(3) {
      flex: 0 0 21%;
      width: 21%;
    }
    .listContent p:nth-child(3) {
      font-size: 10px !important;
    }
    .listTitle h2:nth-child(4),
    .listContent p:nth-child(4) {
      flex: 0 0 25%;
      width: 25%;
    }
    .detailList:nth-child(1) {
      p {
        margin-left: 30%;
      }
    }
    .detailList:nth-child(2) {
      p {
        margin-right: 20%;
      }
    }
  }
`;
